import { render, staticRenderFns } from "./OrganizationPacketCreatorLibrary.vue?vue&type=template&id=70bb7e40&"
import script from "./OrganizationPacketCreatorLibrary.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketCreatorLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports